import { History } from 'history';
import get from 'lodash/get';
import { typedKeys } from '../helpers/object';
import { PartialRecord } from '../helpers/types';
import { updateQuery } from '../helpers/url';
import { useSearch } from './routing';

export function useSearchFilter<Filter extends object>(
  history: History,
  config: {
    defaultPageSize?: number;
    initialFilter?: Filter;
    transform?: PartialRecord<
      keyof Filter,
      {
        parse?: (input: string) => any;
        serialize?: (input: any) => string;
      }
    >;
  } = {},
) {
  const initialFilter = (config?.initialFilter || {}) as Filter;
  const filter = useSearch<Filter>(
    initialFilter,
    typedKeys(config.transform || {}).reduce(
      (all: any, current: any) => {
        if (((config.transform && ((config.transform as any)[current] as any)) || {}).parse) {
          all[current] = (config.transform as any)![current].parse;
        }

        return all;
      },
      {} as typeof config.transform,
    ) as any,
  );

  return {
    filter,
    setFilter: (filter: Filter) => {
      const serializedFilter: any = typedKeys(filter).reduce((all: any, key: any) => {
        const serializer =
          get(config, `transform.${key}.serialize`) || (((value: any) => value) as any);

        const valueToSerialize = (filter as any)[key];
        const serializedValue = serializer(valueToSerialize);

        if (serializedValue === Object(serializedValue)) {
          console.warn(`Skip update of URL param ${key}, object found after serialization`, {
            valueToSerialize,
            serializedValue,
          });
          return all;
        }

        all[key] = serializer(valueToSerialize);

        return all;
      }, {});

      updateQuery(history, serializedFilter);
    },
  };
}
